/* eslint-disable max-len */
import React from 'react';
import { useTheme } from 'styled-components/native';
import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  Use,
} from 'react-native-svg';

import { moderateScale } from '../../../../../scaleHelpers';

const MarketingSummer = (props) => {
  const { colors: { svgHighlight } } = useTheme();

  return (
    <Svg
      height={moderateScale(120)}
      viewBox="0 0 289 121"
      width={moderateScale(287)}
      {...props}
    >
      <Defs>
        <ClipPath id="b">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="c">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="d">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="e">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="f">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="g">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="h">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <ClipPath id="i">
          <Path d="M0 0h289v121H0z" />
        </ClipPath>
        <Mask id="k">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="m">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="o">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="q">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="s">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="u">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="w">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <Mask id="y">
          <G filter="url(#a)">
            <Path
              d="M0 0h289v121H0z"
              style={{
                fill: '#000',
                fillOpacity: 0.701961,
                stroke: 'none',
              }}
            />
          </G>
        </Mask>
        <G clipPath="url(#b)" id="j">
          <Path
            d="m121.883 48.824 4.219-10.37h-3.82l-.4 1.007Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#c)" id="l">
          <Path
            d="M127.207 51.945h-2.41l5.527-13.492h2.414Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#d)" id="n">
          <Path
            d="m145.906 48.723 4.324-10.47h-3.82l-.504 1.106Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#e)" id="p">
          <Path
            d="M151.234 51.844h-2.41l5.63-13.59h2.312Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#f)" id="r">
          <Path
            d="m147.113 92.008 3.52-8.555h-2.414l-1.106 2.715Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#g)" id="t">
          <Path
            d="M150.832 94.523h-2.008l4.524-11.07h2.007Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#h)" id="v">
          <Path
            d="m121.781 89.996 5.426-13.187h-4.02l-1.406 3.523Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
        <G clipPath="url(#i)" id="x">
          <Path
            d="M126.906 94.223h-2.511l7.136-17.414h2.414Zm0 0"
            style={{
              fill: '#fff',
              fillOpacity: 1,
              fillRule: 'nonzero',
              stroke: 'none',
            }}
          />
        </G>
      </Defs>
      <Path
        d="M111.324 31.71c2.012 0 3.32-2.015 2.614-3.827-1.606-3.926-4.926-9.461-11.157-10.067-2.613-.3-5.129.809-7.039 2.118-.199.097-.402.097-.5 0-1.308-1.211-3.32-2.016-5.43-2.016-4.023 0-7.34 2.719-7.34 6.14 0 .301-.199.505-.5.403h-.605c-2.512 0-4.625 1.309-5.328 3.223-.102.199-.402.3-.602.199-.703-.301-1.41-.5-2.21-.5-1.813 0-3.02 1.105-3.723 2.113-.703.906 0 2.215 1.105 2.215Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M92.5 101.1v15.6"
        style={{
          fill: 'none',
          stroke: '#e6ebef',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.8308,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M104.39 83.148c-1.609-1.609-2.113-3.925-1.308-6.039.3-.804.504-1.71.504-2.617 0-2.215-1.008-4.129-2.715-5.637-1.207-1.109-1.508-2.918-.906-4.53a4.52 4.52 0 0 0 .3-1.61c0-3.223-3.214-5.84-7.238-5.84-4.02 0-7.238 2.617-7.238 5.84 0 .605.102 1.105.305 1.61.601 1.612.402 3.421-.906 4.53-1.708 1.508-2.715 3.422-2.715 5.637 0 .906.203 1.711.504 2.617.804 2.114.3 4.43-1.309 6.04-1.91 1.913-3.016 4.43-3.016 7.046 0 6.344 6.434 11.578 14.375 11.578 7.946 0 14.38-5.132 14.38-11.578 0-2.617-1.106-5.132-3.016-7.047Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M92.5 101V75.3m-3.599 6.899 3.497 3.601m.102-3.799 3.4-2.503M92.5 91.4l3.4-2.5"
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeLinecap: 'round',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.4154,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M103.5 102.901c-.902-.8-2.2-1.4-3.598-1.4a5.294 5.294 0 0 0-5.3 5.098c-.502-.198-.902-.299-1.5-.299-2.102 0-3.8 1.6-4.003 3.698-1.2.5-2 1.603-2 3.004 0 1.796 1.402 3.197 3.201 3.197h6.8"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3116,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M89.6 112.199s.102-2.5 2.798-2.1"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3116,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="m138.168 6.844-25.133 19.933v79.528H99.16v10.265l67.656.504-.097-94.523-22.117-15.504Zm136.918 109.222H222.21l18.797 3.625 18.8.204Zm-169.691-45.8a.703.703 0 1 1-1.406 0 .704.704 0 1 1 1.406 0Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M168.629 106.102h-55.594a.218.218 0 0 1-.203-.204v-77.41c0-.101 0-.101.102-.203l26.34-20.433s.097 0 .097-.102l17.594-1.105h.203l11.66 8.253c.102 0 .102.102.102.204v90.597c0 .2-.203.403-.301.403Zm-55.395-.504h55.09V15.3l-11.36-8.055-17.491 1.11-26.137 20.335v76.907Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M146.71 78.316h8.145v2.618h-8.144ZM157.871 106h14.074v11.176h-14.074Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M112.934 68.754h53.48v2.418h-53.48Zm0 0"
        style={{
          fill: '#bac2ca',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M122.684 38.453h8.246v13.59h-8.246Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Use mask="url(#k)" xlinkHref="#j" />
      <Use mask="url(#m)" xlinkHref="#l" />
      <Path
        d="M166.719 27.582h17.793v78.621h-17.793Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M171.242 33.723h13.27v-1.207l-13.672-.203-4.223-3.22-.101 1.61 3.418 2.414c.504.406.906.606 1.308.606Zm0 0"
        style={{
          fill: '#bac2ca',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M189.035 32.414h-16.59v-2.012h16.59c.602 0 1.004.504 1.004 1.004.102.504-.402 1.008-1.004 1.008Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M189.234 32.715h-17.793a.433.433 0 0 1-.402-.403c0-.199.203-.402.402-.402h17.793c.203 0 .403.203.403.402a.43.43 0 0 1-.403.403Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M189.438 30.3 156.563 5.337h-17.09L172.348 30.3h-2.817Zm0 0"
        style={{
          fill: '#bac2ca',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M139.875 5.84c-.2-.203-.504-.305-.902-.305-.305 0-.606.102-.805.402l-30.965 24.465c-.402.403-.3 1.106.102 1.407.504.406 1.207.304 1.61-.098L139.07 8.152l31.668 23.961c.2.2.504.301.805.301.3 0 .504-.102.805-.3.5-.403.5-1.009.097-1.41Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M112.934 28.387v3.625h-4.422Zm0 0"
        style={{
          fill: '#bac2ca',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M112.832 32.313h-4.422c-.101 0-.203-.098-.203-.2 0-.101.102-.203.203-.203h4.422c.102 0 .203.102.203.203 0 .102-.101.2-.203.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="m140.277 9.16-27.043 20.938v-1.91L139.07 8.151Zm0 0"
        style={{
          fill: '#bac2ca',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M189.438 30.602h-17.391c-.102 0-.203-.102-.203-.2 0-.101.101-.203.203-.203h17.39c.102 0 .2.102.2.203 0 .098-.098.2-.2.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M189.438 30.703c-.102 0-.204 0-.204-.101l-32.77-24.864h-17.491a.433.433 0 0 1-.403-.402c0-.203.2-.402.403-.402h17.59c.101 0 .203 0 .203.101L189.539 30c.2.098.2.402.098.5 0 .203-.098.203-.2.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M166.719 10.871h6.129v9.664h-6.13Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M171.543 32.715c-.402 0-.805-.2-1.106-.403L139.07 8.457l-29.957 23.352c-.504.503-1.406.605-2.11.101-.304-.2-.503-.601-.503-1.004 0-.406.102-.707.402-1.008l10.153-7.953 20.91-16.508c.203-.304.605-.402 1.105-.402.403 0 .805.2 1.106.402L172.648 30.2c.301.301.504.707.403 1.008 0 .402-.203.703-.504 1.008-.3.402-.602.5-1.004.5ZM139.07 7.652c.102 0 .203 0 .203.098l31.665 23.96c.304.302.804.302 1.109.099.098-.098.2-.301.2-.403 0-.199-.102-.3-.2-.402L139.676 6.14c-.203-.204-.403-.301-.606-.301-.199 0-.402.098-.601.2L107.406 30.5c-.101.102-.101.203-.101.406 0 .2.101.301.199.403.305.199.805.199 1.105-.102l30.16-23.656c.102.101.204.101.301.101Zm-26.035 98.45c-.101 0-.203-.102-.203-.102V91.305c0-.102.102-.102.203-.102.102 0 .2.102.2.102v14.593c-.098.102-.098.204-.2.204Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M113.035 91.203c-.203 0-.402-.203-.402-.402V28.59a.43.43 0 0 1 .402-.402c.2 0 .403.199.403.402V90.8c0 .2-.204.403-.403.403Zm53.582 15.102a.218.218 0 0 1-.203-.203V86.27c0-.102.102-.2.203-.2.102 0 .2.098.2.2v19.832c.101.101-.098.203-.2.203Zm0-21.445c-.101 0-.203-.098-.203-.2V28.992c0-.101.102-.203.203-.203.102 0 .2.102.2.203V84.66c.101.102-.098.2-.2.2Zm17.895 21.542a.43.43 0 0 1-.403-.402V66.238c0-.203.2-.402.403-.402.199 0 .402.2.402.402V106c-.101.305-.203.402-.402.402Zm0-40.867c-.203 0-.403-.203-.403-.406V32.516c0-.203.2-.403.403-.403.199 0 .402.2.402.403V65.23c-.101.204-.203.305-.402.305Zm4.422-32.82h-1.508c-.2 0-.403-.2-.403-.403 0-.199.204-.402.403-.402h1.508c.402 0 .703-.3.703-.601 0-.305-.301-.606-.703-.606-.2 0-.403-.203-.403-.402 0-.203.203-.403.403-.403.804 0 1.507.602 1.507 1.41 0 .805-.601 1.407-1.507 1.407Zm-68.961 20.539a.218.218 0 0 1-.203-.203V36.945c0-.101.101-.203.203-.203.097 0 .199.102.199.203V52.95c0 .102-.102.305-.2.305Zm13.57 0a.218.218 0 0 1-.203-.203V36.945c0-.101.101-.203.203-.203.102 0 .2.102.2.203V52.95c0 .102-.098.305-.2.305Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M134.547 37.246h-1.004c-.102 0-.203-.101-.203-.2 0-.1.101-.202.203-.202h.703v-1.207h-14.98v1.207h.707c.097 0 .199.101.199.203 0 .098-.102.2-.2.2h-.906c-.101 0-.203-.102-.203-.2v-1.813c0-.101.102-.203.203-.203h15.48c.102 0 .204.102.204.203v1.711c0 .2-.102.301-.203.301Zm0 17.817h-3.719a.211.211 0 0 1-.2-.2c0-.101.099-.203.2-.203h3.418v-1.308h-.703c-.102 0-.203-.098-.203-.2 0-.101.101-.203.203-.203h1.004c.101 0 .203.102.203.203v1.711c0 .102-.102.2-.203.2Zm-4.723 0h-10.758c-.101 0-.203-.098-.203-.2v-1.71c0-.102.102-.204.203-.204h.907c.097 0 .199.102.199.203 0 .102-.102.2-.2.2h-.706v1.21h10.558c.098 0 .2.098.2.2 0 .101-.102.3-.2.3Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M122.684 44.996h8.246v6.95h-8.246Zm0 0"
        style={{
          fill: svgHighlight,
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M130.93 52.246h-8.344a.218.218 0 0 1-.203-.203v-13.59c0-.098.101-.2.203-.2h8.344c.097 0 .199.102.199.2v13.59c.101.102 0 .203-.2.203Zm-8.043-.504h7.84V38.656h-7.84v13.086Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M130.93 45.098h-8.344c-.102 0-.203-.102-.203-.2 0-.101.101-.203.203-.203h8.344c.097 0 .097.102.097.203 0 .098 0 .2-.097.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M126.906 44.996c-.097 0-.199-.098-.199-.2v-6.44c0-.102.102-.204.2-.204.1 0 .202.102.202.203v6.442c-.101.2-.203.2-.203.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M146.71 38.254h8.243v13.59h-8.242ZM122.281 77.41h8.848v14.8h-8.848Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Use mask="url(#o)" xlinkHref="#n" />
      <Use mask="url(#q)" xlinkHref="#p" />
      <Path
        d="M147.113 83.453h7.64v11.07h-7.64Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Use mask="url(#s)" xlinkHref="#r" />
      <Use mask="url(#u)" xlinkHref="#t" />
      <Use mask="url(#w)" xlinkHref="#v" />
      <Use mask="url(#y)" xlinkHref="#x" />
      <Path
        d="M154.953 52.246h-8.344c-.097 0-.199-.101-.199-.203v-13.59c0-.098.102-.2.2-.2h8.343c.102 0 .203.102.203.2v13.59c.102.102-.101.203-.203.203Zm-8.039-.504h7.84V38.656h-7.84Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M154.953 45.098h-8.344c-.097 0-.097-.102-.097-.2 0-.101.097-.203.097-.203h8.344c.102 0 .102.102.102.203 0 .098 0 .2-.102.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M150.832 44.996c-.098 0-.098-.098-.098-.2v-6.44c0-.102.098-.204.098-.204s.102.102.102.203v6.442c.101.2 0 .2-.102.2Zm-30.859 49.93c-.102 0-.203-.098-.203-.2v-18.42c0-.102.101-.203.203-.203.097 0 .199.101.199.203v18.422c0 .101-.102.199-.2.199Zm13.57-.098c-.102 0-.102-.101-.102-.101V76.305c0-.102.102-.203.102-.203s.102.101.102.203v18.422s0 .101-.102.101Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M119.973 76.605h-.907c-.101 0-.203-.101-.203-.199v-1.71c0-.102.102-.204.203-.204h14.075c.101 0 .199.102.199.203 0 .098-.098.2-.2.2h-13.874v1.207h.707c.097 0 .199.101.199.203 0 .101-.102.3-.2.3Zm22.817 18.727c-.099 0-.2-.102-.2-.203V76.305c0-.102.101-.203.2-.203.1 0 .202.101.202.203v18.824c.102.101 0 .203-.203.203Zm0 10.668c-.099 0-.099-.102-.099-.102v-9.46c0-.102.098-.102.098-.102l.102.102v9.46c.101.102 0 .102-.102.102Zm15.28 0c-.097 0-.097-.102-.097-.102V76.305c0-.102.097-.203.097-.203s.102.101.102.203v29.593c.101.102 0 .102-.102.102Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M159.078 76.605h-1.008c-.097 0-.199-.101-.199-.199 0-.101.102-.203.2-.203h.702v-1.207h-16.585v1.207h.703c.101 0 .203.102.203.203 0 .098-.102.2-.203.2h-.903c-.101 0-.203-.102-.203-.2v-1.71c0-.102.102-.204.203-.204h17.09c.098 0 .2.102.2.203v1.711s-.102.2-.2.2ZM134.547 96.64h-15.18c-.101 0-.199-.1-.199-.1v-1.712c0-.101.098-.101.2-.101h.605c.097 0 .199.101.199.101s-.102.098-.2.098h-.503v1.41h14.879v-1.41h-.805c-.102 0-.102-.098-.102-.098l.102-.101h1.004c.101 0 .101.101.101.101v1.711c0 .102-.101.102-.101.102Zm-3.418-4.128h-8.746c-.102 0-.2-.102-.2-.203V77.41c0-.097.098-.2.2-.2h8.746c.101 0 .203.103.203.2v14.8c0 .2-.102.302-.203.302Zm-8.445-.504h8.246V77.715h-8.246Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M126.809 91.906h1.105v13.692h-1.105Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M128.012 105.8h-1.203a.218.218 0 0 1-.204-.202V91.906c0-.097.102-.199.204-.199h1.105c.098 0 .2.102.2.2v13.69c.1.102 0 .204-.102.204Zm-.903-.503h.602V92.109h-.602Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M162.797 91.906h1.406v13.992h-1.406Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M164.203 106.203h-1.406c-.203 0-.3-.101-.3-.305V91.906c0-.199.097-.3.3-.3h1.406c.203 0 .3.101.3.3v13.992c0 .204-.097.305-.3.305Zm-1.105-.605h.804V92.21h-.804Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M130.629 91.906h1.105v13.692h-1.105Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M131.734 105.8h-1.105a.218.218 0 0 1-.203-.202V91.906c0-.097.101-.199.203-.199h1.105c.098 0 .2.102.2.2v13.69c0 .102-.102.204-.2.204Zm-.906-.503h.602V92.109h-.602Zm25.938.906h-11.762a.218.218 0 0 1-.203-.203V76.809c0-.102.101-.204.203-.204h11.762c.097 0 .199.102.199.204V106s-.102.203-.2.203Zm-11.563-.504h11.262V77.008h-11.262Zm-14.074-20.336h-8.645c-.101 0-.101-.097-.101-.097l.101-.102h8.645c.101 0 .101.102.101.102l-.101.097Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M126.707 85.363c-.102 0-.102-.097-.102-.097v-7.754c0-.102.102-.102.102-.102l.102.102v7.652c0 .102-.102.2-.102.2Zm17.09-32.109a.218.218 0 0 1-.203-.203V36.945c0-.101.101-.203.203-.203.101 0 .2.102.2.203V52.95c.1.102 0 .305-.2.305Zm13.672 0a.218.218 0 0 1-.203-.203V36.945c0-.101.101-.203.203-.203.101 0 .199.102.199.203V52.95c0 .102-.098.305-.2.305Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M153.648 35.234h4.723v1.711h-.902"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M158.371 37.246h-1.004c-.101 0-.199-.101-.199-.2 0-.1.098-.202.2-.202h.702v-1.207h-4.523c-.102 0-.2-.102-.2-.203 0-.102.098-.2.2-.2h4.726c.098 0 .2.098.2.2v1.71c.203 0 .101.102-.102.102Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M143.898 36.945h-.906v-1.71h9.551"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M143.898 37.246h-.906c-.101 0-.203-.101-.203-.2v-1.812c0-.101.102-.203.203-.203h9.551c.102 0 .2.102.2.203 0 .098-.098.2-.2.2h-9.25v1.207h.703c.102 0 .203.101.203.203 0 .101-.203.402-.3.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M143.898 53.05h-.906v1.712h15.38V53.05h-.903"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M158.371 55.063h-15.48a.211.211 0 0 1-.2-.2v-1.71c0-.102.098-.204.2-.204h.906c.101 0 .2.102.2.203 0 .102 0 .2-.099.2h-.707v1.21h14.98v-1.21h-.702c-.102 0-.203-.098-.203-.2 0-.101.101-.203.203-.203h1.004c.101 0 .203.102.203.203v1.711c0 .102-.102.2-.305.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M184.21 106H98.96v11.176h85.552V106Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M184.512 117.578H98.96c-.203 0-.402-.203-.402-.402V106c0-.2.199-.402.402-.402h85.55c.2 0 .403.203.403.402v11.176c-.101.199-.203.402-.402.402Zm-85.25-.805h84.847v-10.468H99.262Zm55.593-35.535h-8.246c-.097 0-.199-.101-.199-.203v-2.719c0-.097.102-.199.2-.199h8.245c.098 0 .2.102.2.2v2.718c0 .102-.102.203-.2.203Zm-8.042-.402h7.84V78.52h-7.84Zm7.941 13.789h-7.64c-.102 0-.2-.102-.2-.2V83.353c0-.102.098-.204.2-.204h7.64c.101 0 .2.102.2.204v11.074c0 .199-.099.199-.2.199Zm-7.54-.3h7.34V83.55h-7.34Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M102.176 98.352v-28.29h3.32v34.731h-3.32Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M105.496 105.094h-3.32c-.2 0-.403-.2-.403-.403V70.062c0-.199.204-.402.403-.402h3.32c.2 0 .402.203.402.403v34.73c0 .203-.203.3-.402.3Zm-2.918-.703h2.613V70.363h-2.613Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M100.469 67.145v1.609h55.09v-2.012"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M155.559 69.156h-55.09a.43.43 0 0 1-.403-.402v-1.711c0-.2.2-.402.403-.402.199 0 .402.203.402.402v1.41h54.285v-1.71c0-.204.2-.403.403-.403.199 0 .402.2.402.402v2.012c0 .203-.203.402-.402.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="m166.816 60.398-13.671 5.137-53.782-.203 13.27-4.934"
        style={{
          fill: '#bac2ca',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M99.063 65.434h.5l53.484.101"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="m153.047 65.734-53.984-.101c-.102 0-.204-.098-.204-.2 0-.101.102-.203.204-.203h.5l53.582.102c.101 0 .203.102.203.203 0 .098-.102.2-.301.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M100.57 67.445h-1.507c-.708 0-1.31-.504-1.31-1.207 0-.703.602-1.207 1.31-1.207.199 0 .398.2.398.403 0 .199-.2.402-.398.402-.305 0-.504.2-.504.504 0 .3.199.504.504.504h1.507c.2 0 .403.199.403.402 0 .2-.203.2-.403.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M130.227 67.344H100.57c-.101 0-.203-.098-.203-.2 0-.101.102-.203.203-.203h29.657c.097 0 .199.102.199.204 0 .101-.102.199-.2.199Zm23.218 0h-21.914a.211.211 0 0 1-.199-.2c0-.101.098-.203.2-.203h21.913c.102 0 .203.102.203.204 0 .101-.101.199-.203.199Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="m154.25 64.93 1.508 1.007s-1.305 1.004-1.91 1.106c-.602.102-1.305-.402-.703-1.309.3-.605 1.105-.804 1.105-.804Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M165.512 63.117c-.102 0-.102 0-.102-.101 0-.102 0-.2.102-.2l1.004-.304v-2.114c0-.101.101-.101.101-.101.102 0 .102.101.102.203v2.215c0 .101 0 .101-.102.101Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M153.75 67.445h-.203c-.3 0-.402-.101-.602-.3h-.101c-.301-.204-.403-.707-.301-1.11.102-.402.3-.703.703-.906l13.168-5.031c.102 0 .305 0 .305.101 0 .098 0 .301-.102.301l-13.172 5.035c-.3.098-.398.3-.398.5-.102.305 0 .504.2.606h.1c.098.101.2.101.301.101h.301c.403 0 .703-.203 1.309-.402l11.258-4.13c.101 0 .3 0 .3.102s0 .301-.097.301l-11.262 4.13c-.504.198-1.004.402-1.406.402-.203.3-.203.3-.301.3Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M98.86 65.836c-.2 0-.301-.102-.403-.203-.102-.2 0-.403.203-.504l13.871-5.133h53.883c.203 0 .402.203.402.402a.43.43 0 0 1-.402.403h-53.781l-13.774 5.136c.102-.101 0-.101 0-.101Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M101.574 69.156v1.008h4.524v-1.008"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M106.098 70.465h-4.524c-.101 0-.203-.102-.203-.2v-1.109c0-.101.102-.199.203-.199.102 0 .2.098.2.2v.804h4.023v-.805c0-.101.101-.199.2-.199.1 0 .202.098.202.2v1.109c.2.097.102.199-.101.199Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M133.34 69.96h3.32v34.833h-3.32Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M136.66 104.996h-3.32c-.098 0-.2-.101-.2-.203V69.961c0-.098.102-.2.2-.2h3.32c.098 0 .2.102.2.2v34.832c0 .102-.102.203-.2.203Zm-3.117-.504h2.812V70.164h-2.812Zm32.973-35.336h-10.957a.43.43 0 0 1-.403-.402c0-.2.2-.402.403-.402h10.957c.203 0 .402.203.402.402a.43.43 0 0 1-.402.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M100.973 105.598v-1.008h5.828v1.008"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M100.973 105.898c-.102 0-.203-.097-.203-.199v-1.11c0-.097.101-.198.203-.198h5.93c.1 0 .199.101.199.199v1.008c0 .101-.098.203-.2.203a.218.218 0 0 1-.203-.203v-.805h-5.426v.805c-.101.203-.203.3-.3.3Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M131.832 105.598v-1.106h5.934v1.106"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M131.832 105.898c-.098 0-.2-.097-.2-.199v-1.11c0-.097.102-.198.2-.198h5.934c.097 0 .199.101.199.199v1.11c0 .1-.102.198-.2.198-.1 0-.202-.097-.202-.199v-.804h-5.426v.804c-.102.102-.203.2-.305.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M160.082 80.23v24.563h-3.418V69.961h3.418v9.262"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M160.082 104.996h-3.316a.218.218 0 0 1-.203-.203V69.961c0-.098.101-.2.203-.2h3.316c.102 0 .2.102.2.2v9.363c0 .102-.098.203-.2.203-.102 0-.2-.101-.2-.203v-9.058h-2.917v34.324h2.816V80.23c0-.101.102-.203.2-.203.101 0 .203.102.203.203v24.563c.097.102 0 .203-.102.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M155.258 105.598v-1.008h5.828v1.008"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M155.258 105.898c-.102 0-.203-.097-.203-.199v-1.008c0-.101.101-.199.203-.199h5.93c.101 0 .203.098.203.2v1.007c0 .102-.102.2-.203.2a.211.211 0 0 1-.2-.2v-.804h-5.43v.804c-.101 0-.203.2-.3.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M129.219 114.055v-8.356l7.441-6.441v-1.711l-8.547 7.45v9.358"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M128.113 114.656a.211.211 0 0 1-.199-.199v-9.363c0-.098 0-.098.098-.2l8.648-7.449c.098-.101.2-.101.3 0 .102 0 .102.102.102.2v1.812c0 .102 0 .102-.101.203l-7.34 6.34v8.156c0 .098-.101.2-.2.2-.1 0-.202-.102-.202-.2V105.7c0-.101 0-.101.101-.203l7.34-6.34v-1.11l-8.144 7.048v9.261c-.2.102-.301.301-.403.301Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M135.953 108.719h-2.512v2.719h-2.914v2.718h-2.414v2.918h24.934v-5.336h2.512v-3.02h-3.016"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M153.047 117.273h-24.934a.211.211 0 0 1-.199-.199v-2.918c0-.101.098-.203.2-.203h2.21v-2.414c0-.102.102-.203.203-.203h2.614v-2.617c0-.102.101-.203.199-.203h2.613c.102 0 .203.101.203.203a.218.218 0 0 1-.203.203h-2.308v2.516c0 .101-.102.199-.204.199h-2.613v2.418c0 .101-.101.199-.2.199h-2.214v2.418h24.43v-5.035c0-.098.101-.2.203-.2h2.21v-2.617h-2.714a.218.218 0 0 1-.203-.203c0-.101.101-.199.203-.199h2.914c.102 0 .203.098.203.2v3.12a.218.218 0 0 1-.203.203h-2.21v5.032c0 .203-.102.3-.2.3Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M145.504 114.355h-13.469c-.101 0-.203-.101-.203-.199 0-.101.102-.203.203-.203h13.469c.101 0 .203.102.203.203 0 .098-.102.2-.203.2Zm4.828-2.617h-17.293c-.101 0-.2-.101-.2-.199 0-.102.099-.203.2-.203h17.293c.098 0 .2.102.2.203 0 .098-.102.2-.2.2Zm2.613-2.816h-15.28c-.102 0-.2-.102-.2-.203 0-.102.097-.203.2-.203h15.28c.102 0 .2.101.2.203 0 .101-.098.203-.2.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M149.023 114.055v-8.356l7.743-6.543v-1.812l-8.848 7.652v9.36"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M147.918 114.656a.211.211 0 0 1-.2-.199v-9.363c0-.098 0-.098.098-.2l8.848-7.652c.102-.101.2-.101.3 0 .102 0 .102.102.102.203v1.813c0 .097 0 .097-.101.199l-7.54 6.543v8.156c0 .098-.1.2-.198.2-.102 0-.204-.102-.204-.2V105.7c0-.101 0-.101.102-.203l7.54-6.543v-1.105l-8.345 7.246v9.261c-.203.102-.3.301-.402.301Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M155.258 106.102v2.617h-2.613v2.82h-2.313v2.516h-2.414v3.12h10.355v-11.073Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M158.273 117.375h-10.457c-.097 0-.199-.102-.199-.2v-3.019c0-.101.102-.203.2-.203h2.113v-2.316c0-.098.097-.2.199-.2h2.113v-2.718c0-.102.098-.203.2-.203h2.413v-2.414c0-.102.098-.204.2-.204h3.015c.102 0 .203.102.203.204v11.074c0 .097 0 .097-.101.199-.102.102.2 0 .101 0Zm-10.156-.504h9.953v-10.566h-2.511v2.414a.218.218 0 0 1-.204.203h-2.41v2.516c0 .101-.101.199-.203.199h-2.11v2.316a.218.218 0 0 1-.202.203h-2.11Zm-12.164-8.051c-.098 0-.2-.101-.2-.203v-2.414c0-.101.102-.203.2-.203.102 0 .203.102.203.203v2.414a.218.218 0 0 1-.203.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M160.082 90.5h6.535v1.406h-6.535Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M166.617 92.11h-6.535c-.102 0-.2-.102-.2-.204V90.5c0-.102.098-.203.2-.203h6.535c.102 0 .2.101.2.203v1.406c0 .102-.098.203-.2.203Zm-6.234-.505h6.031V90.7h-6.031Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M108.11 91.906h1.105v13.692h-1.106Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M109.215 105.8h-1.106a.218.218 0 0 1-.203-.202V91.906c0-.097.102-.199.203-.199h1.106c.101 0 .2.102.2.2v13.69c.1.102 0 .204-.2.204Zm-.805-.503h.602V92.109h-.602Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M111.828 91.906h1.106v13.692h-1.106Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M113.035 105.8h-1.105a.218.218 0 0 1-.203-.202V91.906c0-.097.101-.199.203-.199h1.105c.102 0 .2.102.2.2v13.69c0 .102-.098.204-.2.204Zm-.906-.503h.605V92.109h-.605Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M115.648 91.906h1.106v13.692h-1.106Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M116.754 105.8h-1.106a.218.218 0 0 1-.203-.202V91.906c0-.097.102-.199.203-.199h1.106c.101 0 .2.102.2.2v13.69c0 .102-.099.204-.2.204Zm-.906-.503h.605V92.109h-.605Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M119.367 91.906h1.106v13.692h-1.106Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M120.473 105.8h-1.106c-.101 0-.199-.1-.199-.202V91.906c0-.097.098-.199.2-.199h1.105c.101 0 .203.102.203.2v13.69c.097.102 0 .204-.203.204Zm-.903-.503h.602V92.109h-.602Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M123.086 91.906h1.105v13.692h-1.105Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M124.191 105.8h-1.105c-.098 0-.2-.1-.2-.202V91.906c0-.097.102-.199.2-.199h1.105c.102 0 .204.102.204.2v13.69c.101.102 0 .204-.204.204Zm-.8-.503h.601V92.109h-.601Zm26.136-11.375c-.101 0-.101 0-.101-.102v-9.765c0-.102 0-.102.101-.102.102 0 .102 0 .102.102v9.765s0 .102-.102.102Zm2.715 0c-.101 0-.101 0-.101-.102v-9.765c0-.102 0-.102.101-.102.098 0 .098 0 .098.102v9.765l-.098.102Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M154.25 88.988h-6.734c-.102 0-.102 0-.102-.101 0-.102 0-.102.102-.102h6.734c.102 0 .102 0 .102.102 0 .101-.102.101-.102.101Zm-5.023-8.152c-.102 0-.102 0-.102-.102V78.72c0-.098 0-.098.102-.098.097 0 .097 0 .097.098v2.015c0 .102-.097.102-.097.102Zm2.711 0c-.098 0-.098 0-.098-.102V78.72c0-.098 0-.098.097-.098.102 0 .102 0 .102.098v2.015c0 .102 0 .102-.101.102Zm22.722-45.805h-8.144c-.102 0-.102 0-.102-.101 0-.098 0-.098.102-.098h8.144c.098 0 .098 0 .098.098 0 .101-.098.101-.098.101Zm9.649 3.223h-14.075c-.097 0-.097 0-.097-.102 0-.101 0-.101.097-.101h14.075c.101 0 .101 0 .101.101 0 .102 0 .102-.101.102Zm0 3.121h-7.84c-.102 0-.102 0-.102-.102 0-.101 0-.101.102-.101h7.84c.101 0 .101 0 .101.101 0 .102 0 .102-.101.102Zm-10.352 0h-5.633c-.097 0-.097 0-.097-.102 0-.101 0-.101.097-.101h5.633c.098 0 .098 0 .098.101 0 .102-.098.102-.098.102Zm8.945 3.121H165.41c-.101 0-.101 0-.101-.101 0-.102 0-.102.101-.102h17.492c.102 0 .102 0 .102.102 0 .101-.102.101-.102.101Zm-1.406 21.844h-11.262c-.097 0-.097 0-.097-.102 0-.101 0-.101.097-.101h11.262c.098 0 .098 0 .098.101 0 .102 0 .102-.098.102Zm2.813 3.219h-7.84c-.102 0-.102 0-.102-.098 0-.102 0-.102.102-.102h7.84c.101 0 .101 0 .101.102 0 .098 0 .098-.101.098Zm-10.352 0h-5.633c-.097 0-.097 0-.097-.098 0-.102 0-.102.097-.102h5.633c.098 0 .098 0 .098.102 0 .098-.098.098-.098.098Zm6.231 3.121h-10.454c-.101 0-.101 0-.101-.102 0-.098 0-.098.101-.098h10.453c.102 0 .102 0 .102.098 0 .102 0 .102-.101.102Zm4.121-25.067h-11.36c-.101 0-.101 0-.101-.097 0-.102 0-.102.101-.102h11.36c.101 0 .101 0 .101.102 0 .097 0 .097-.101.097Zm-4.625 3.024h-15.782c-.101 0-.101 0-.101-.102 0-.101 0-.101.101-.101h15.782c.101 0 .101 0 .101.101 0 .102 0 .102-.101.102Zm4.625 3.117h-14.075c-.097 0-.097 0-.097-.098 0-.101 0-.101.097-.101h14.075c.101 0 .101 0 .101.101 0 .098 0 .098-.101.098Zm0 3.121h-7.84c-.102 0-.102 0-.102-.102 0-.097 0-.097.102-.097h7.84c.101 0 .101 0 .101.097 0 .102 0 .102-.101.102Zm-10.352 0h-5.633c-.097 0-.097 0-.097-.102 0-.097 0-.097.097-.097h5.633c.098 0 .098 0 .098.097 0 .102-.098.102-.098.102Zm10.352 3.223h-12.97c-.097 0-.097 0-.097-.102 0-.101 0-.101.098-.101h12.969c.101 0 .101 0 .101.101 0 .102 0 .102-.101.102Zm.203 3.121h-6.938c-.101 0-.101 0-.101-.102 0-.101 0-.101.101-.101h6.938c.097 0 .097 0 .097.101 0 .102 0 .102-.097.102Zm-1.61 12.984H165.41c-.101 0-.101 0-.101-.101 0-.098 0-.098.101-.098h17.492c.102 0 .102 0 .102.098 0 .101-.102.101-.102.101ZM171.34 98.047h-2.211c-.102 0-.102 0-.102-.098 0-.101 0-.101.102-.101h2.21c.102 0 .102 0 .102.101 0 .098 0 .098-.101.098Zm-2.211 3.223h-2.613c-.102 0-.102 0-.102-.102s0-.102.102-.102h2.613c.101 0 .101 0 .101.102s0 .102-.101.102Zm15.18-21.946h-11.36c-.101 0-.101 0-.101-.101 0-.098 0-.098.101-.098h11.36c.101 0 .101 0 .101.098 0 .101 0 .101-.101.101Zm-4.625 3.02h-15.782c-.101 0-.101 0-.101-.102 0-.097 0-.097.101-.097h15.782c.101 0 .101 0 .101.097 0 .102 0 .102-.101.102Zm4.625 3.121h-14.075c-.097 0-.097 0-.097-.102 0-.097 0-.097.097-.097h14.075c.101 0 .101 0 .101.097 0 .102 0 .102-.101.102Zm0 3.121h-3.215c-.102 0-.102 0-.102-.102 0-.101 0-.101.102-.101h3.215c.101 0 .101 0 .101.101 0 .102 0 .102-.101.102Zm-10.352 0h-5.633c-.097 0-.097 0-.097-.102 0-.101 0-.101.097-.101h5.633c.098 0 .098 0 .098.101 0 .102-.098.102-.098.102Zm10.352 3.223h-13.57c-.102 0-.102 0-.102-.102s0-.102.101-.102h13.57c.102 0 .102 0 .102.102s0 .102-.101.102Zm-9.246 3.117h-8.344c-.102 0-.102 0-.102-.098 0-.101 0-.101.102-.101h8.344c.097 0 .097 0 .097.101 0 .098 0 .098-.097.098Zm-32.071-83.551h-7.742c-.098 0-.098 0-.098-.102 0-.097 0-.097.098-.097h7.742c.102 0 .102 0 .102.097 0 .102-.102.102-.102.102Zm-.702 2.82h-11.161c-.102 0-.102 0-.102-.101 0-.102 0-.102.102-.102h11.16c.102 0 .102 0 .102.102 0 .101-.102.101-.102.101Zm8.847 3.121h-18.5c-.102 0-.102 0-.102-.101 0-.102 0-.102.102-.102h18.5c.097 0 .097 0 .097.102 0 .101 0 .101-.097.101Zm0 10.368h-18.5c-.102 0-.102 0-.102-.102s0-.102.102-.102h18.5c.097 0 .097 0 .097.102s0 .102-.097.102Zm-21.414 0h-2.414c-.102 0-.102 0-.102-.102s0-.102.102-.102h2.414c.101 0 .101 0 .101.102s-.101.102-.101.102Zm15.48-3.625h-24.629c-.101 0-.101 0-.101-.102 0-.098 0-.098.101-.098h24.63c.1 0 .1 0 .1.098 0 .102 0 .102-.1.102Zm7.844 0h-4.93c-.097 0-.097 0-.097-.102 0-.098 0-.098.097-.098h4.93c.098 0 .098 0 .098.098 0 .102 0 .102-.098.102Zm-23.527-3.524h-6.333c-.101 0-.101 0-.101-.101 0-.098 0-.098.102-.098h6.332c.101 0 .101 0 .101.098 0 .101 0 .101-.101.101Zm25.738 0h-14.375c-.102 0-.102 0-.102-.101 0-.098 0-.098.102-.098h14.472c.102 0 .102 0 .102.098 0 .101-.102.101-.2.101Zm8.542 23.961h-1.706c-.102 0-.102 0-.102-.101 0-.102 0-.102.102-.102h1.707c.101 0 .101 0 .101.102 0 .101 0 .101-.101.101Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M112.23 65.734h1.707v1.11h-1.707Zm43.833 3.422v1.008h4.523v-1.008"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M160.586 70.363h-4.524c-.101 0-.203-.097-.203-.199v-1.008c0-.101.102-.199.203-.199.098 0 .2.098.2.2v.706h4.02v-.707c0-.101.1-.199.202-.199.102 0 .2.098.2.2v1.007c.203.102.101.2-.098.2Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M132.637 69.156v1.11h4.625v-1.11"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M137.262 70.465h-4.524c-.101 0-.203-.102-.203-.2v-1.109c0-.101.102-.199.203-.199.102 0 .2.098.2.2v.804h4.023v-.805c0-.101.101-.199.2-.199.1 0 .202.098.202.2v1.109c.102.097 0 .199-.101.199Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M105.594 90.902h27.746v1.407h-27.746Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M133.34 92.512h-27.746c-.098 0-.2-.102-.2-.203v-1.407c0-.101.102-.203.2-.203h27.746c.101 0 .203.102.203.203v1.407a.218.218 0 0 1-.203.203Zm-27.543-.504h27.242v-.906h-27.242Zm168.687 25.57h-90.98c-.2 0-.402-.203-.402-.402 0-.203.203-.403.402-.403h90.98c.2 0 .403.2.403.403 0 .199-.203.402-.403.402Zm9.149 0h-6.434c-.203 0-.402-.203-.402-.402 0-.203.2-.403.402-.403h6.434c.199 0 .402.2.402.403 0 .199-.203.402-.402.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M29.293 89.29a2.115 2.115 0 0 1-2.11 2.116 2.116 2.116 0 0 1 0-4.23c1.165 0 2.11.945 2.11 2.113Zm-1.508 20.132c0 .781-.629 1.41-1.406 1.41a1.409 1.409 0 1 1 1.406-1.41Zm1.105-37.649a1.61 1.61 0 0 1-1.609 1.614 1.61 1.61 0 0 1-1.605-1.614c0-.886.719-1.609 1.605-1.609.89 0 1.61.723 1.61 1.61Zm74.294-22.949a.907.907 0 1 1-1.814-.001.907.907 0 0 1 1.814.001ZM16.223 84.258a.904.904 0 1 1-1.809 0 .904.904 0 1 1 1.809 0Zm1.308 17.715a1.808 1.808 0 1 1-3.617 0 1.808 1.808 0 1 1 3.617 0Zm105.457-89.895a1.811 1.811 0 1 1-3.622.003 1.811 1.811 0 0 1 3.622-.003Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M8.281 117.578H4.664c-.203 0-.402-.203-.402-.402a.43.43 0 0 1 .402-.403h3.719c.203 0 .402.2.402.403 0 .199-.3.402-.504.402Zm91.383 0H11.2c-.203 0-.402-.203-.402-.402 0-.203.2-.403.402-.403h88.465c.2 0 .402.2.402.403 0 .199-.203.402-.402.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M257.898 24.863c1.407 0 2.211-1.71 1.305-2.816-1.61-1.813-4.824-3.121-8.445-3.121-.602 0-1.203 0-1.707.101-.602.098-1.207-.402-1.207-1.109 0-3.223-4.02-5.84-9.047-5.84-1.406 0-2.715.203-3.922.606-.5.203-1.105-.2-1.305-.704-1.007-4.734-6.132-8.355-12.265-8.355-6.938 0-12.567 4.527-12.567 10.168v.602c-.3 0-.601-.102-.906-.102-2.613 0-4.723 1.71-5.527 4.027-.203.504-.703.805-1.207.707-.504-.101-1.004-.203-1.61-.203-1.808 0-3.515.906-4.523 2.215-1.207 1.512-.102 3.824 1.91 3.824h61.023Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M96.848 117.375h-32.27c-.098 0-.2-.102-.2-.2 0-.1.102-.202.2-.202h32.27c.101 0 .203.101.203.203 0 .097-.102.199-.203.199Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M198.887 109.926v-.102c0-3.02-2.414-5.433-5.328-5.433-.602 0-1.309.101-1.809.3v-.504a3.606 3.606 0 0 0-3.621-3.62 3.51 3.51 0 0 0-3.016 1.71 5.924 5.924 0 0 0-3.922-1.511c-3.113 0-5.726 2.515-5.828 5.738-.504-.2-1.008-.3-1.61-.3-2.312 0-4.12 1.812-4.323 4.124-1.305.504-2.11 1.813-2.11 3.324 0 2.012 1.61 3.621 3.52 3.621h27.242c.2 0 .402.102.602.102 1.91 0 3.52-1.61 3.52-3.621 0-2.215-1.509-3.727-3.317-3.828Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M198.082 116.973c.2 0 .402.101.602.101 1.91 0 3.52-1.61 3.52-3.625 0-1.91-1.509-3.523-3.317-3.625v-.097c0-3.02-2.414-5.438-5.328-5.438-.602 0-1.207.102-1.711.3v.204s1.207.906 1.507 1.309c0 0 2.215-.403 3.622 1.41 1.507 1.812 1.207 3.12 1.207 3.12s-1.309 0-2.211.805c0 0 2.109-.402 3.214.704 1.106 1.109.606 4.53-2.914 4.73v.102Zm-17.492-14.598s2.715-.3 4.726 2.215c0 0 1.407-2.715 3.72-2.215 2.312.406 2.612 2.418 2.612 2.418l.102-.102v-.402a3.61 3.61 0 0 0-3.621-3.625c-1.305 0-2.41.707-3.016 1.711a5.94 5.94 0 0 0-3.922-1.508c-2.812 0-5.125 2.012-5.726 4.73.902-1.105 3.113-3.222 5.125-3.222Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M198.684 117.273H170.84a3.82 3.82 0 0 1-3.82-3.824c0-1.508.804-2.816 2.21-3.422.2-2.316 2.211-4.129 4.524-4.129.504 0 .906.102 1.309.204.3-3.122 2.914-5.637 6.03-5.637 1.407 0 2.716.504 3.821 1.41.703-1.008 1.91-1.613 3.113-1.613 2.114 0 3.82 1.71 3.82 3.925v.102c.505-.102 1.008-.2 1.508-.2 1.91 0 3.622.907 4.625 2.516.102.102 0 .301-.097.301-.102.102-.305 0-.305-.101a5.068 5.068 0 0 0-4.223-2.313c-.601 0-1.203.098-1.707.301h-.203s-.097-.102-.097-.203v-.5c0-1.914-1.508-3.426-3.32-3.426a3.326 3.326 0 0 0-2.813 1.613c0 .098-.102.098-.203.098-.098 0-.098 0-.2-.098a5.51 5.51 0 0 0-3.718-1.41c-3.016 0-5.43 2.414-5.63 5.438 0 .097 0 .199-.1.199-.102 0-.204.101-.204 0-.5-.2-1.004-.3-1.508-.3-2.109 0-3.918 1.71-4.02 3.823 0 .102-.1.203-.1.203-1.208.5-2.012 1.711-2.012 3.118 0 1.812 1.507 3.324 3.32 3.324h27.14c.102 0 .102-.102.204 0 .199 0 .402.101.601.101 1.809 0 3.317-1.511 3.317-3.324a3.311 3.311 0 0 0-3.114-3.32c-.101 0-.203-.102-.203-.305l.3-.097h-.198c0-.707-.102-1.309-.403-2.016-.101-.098 0-.3.102-.3.098-.102.3 0 .3.1.302.602.403 1.31.403 2.012 1.91.204 3.316 1.813 3.316 3.825-.101 2.215-1.808 3.925-3.921 3.925Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M187.828 104.59s4.524-1.508 6.031 2.82"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M193.86 107.613c-.102 0-.2-.101-.2-.203-1.41-4.027-5.531-2.719-5.73-2.617-.102 0-.301 0-.301-.203 0-.2 0-.3.2-.3 0 0 4.726-1.61 6.331 2.917-.097.203-.097.406-.3.406Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M171.543 109.824s.102-2.715 3.016-2.312"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M171.543 110.129c-.102 0-.3-.102-.203-.305 0-.097 0-1.308.906-2.011.602-.504 1.406-.704 2.414-.504.098 0 .2.101.2.304 0 .098-.102.2-.301.2-.805-.102-1.508 0-2.012.402-.703.605-.805 1.61-.805 1.71 0 0-.097.204-.199.204Zm28.852 4.125c-.204-.098-.301-.2-.204-.3.102-.2.102-.403.102-.704a2.23 2.23 0 0 0-2.211-2.215c-.2 0-.504 0-.703.102-.102 0-.3 0-.3-.203 0-.102 0-.301.198-.301.301-.102.606-.102.907-.102a2.705 2.705 0 0 1 2.714 2.719c0 .3 0 .504-.101.805-.102.199-.203.199-.402.199Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M167.02 11.477h5.828v1.207h-5.828Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M166.617 10.367v1.11h.2v9.16l-2.41-1.813v-7.347s-.305-.301-.305-.403c0-.101.101-.605.101-.605l.203-.2Zm0 0"
        style={{
          fill: '#dce2e7',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M172.848 20.836h-6.032l-2.41-1.809c-.101 0-.101-.101-.101-.203v-7.246c0-.101.101-.203.199-.203.101 0 .203.102.203.203v7.145l2.313 1.71h5.527v-8.855c0-.101.101-.203.203-.203.098 0 .2.102.2.203v9.16c.1 0 0 .098-.102.098Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M166.918 17.414a.211.211 0 0 1-.2-.2v-5.839c0-.102.098-.2.2-.2.102 0 .2.098.2.2v5.84c0 .101-.098.2-.2.2Zm0 2.016c-.102 0-.2-.102-.2-.203v-1.309c0-.102.098-.2.2-.2.102 0 .2.098.2.2v1.309c0 .101-.098.203-.2.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M172.95 11.676h-8.345a.686.686 0 0 1-.703-.703v-.301a.69.69 0 0 1 .703-.707h8.344a.69.69 0 0 1 .703.707v.3c0 .403-.3.704-.703.704Zm-8.345-1.207c-.101 0-.199.101-.199.203v.3c0 .102.098.204.2.204h8.343a.218.218 0 0 0 .203-.203v-.301a.218.218 0 0 0-.203-.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M166.719 11.578a.218.218 0 0 1-.203-.203v-1.008c0-.097.101-.199.203-.199.097 0 .199.102.199.2v1.007s-.102.203-.2.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M232.063 72.078c-7.04-42.683-16.993-40.77-16.993-40.77v.098-.097s-9.55-1.914-16.586 40.77a25.892 25.892 0 0 0-.3 4.023c0 11.476 7.64 20.84 17.09 20.84 9.449 0 17.09-9.364 17.09-20.84a27.35 27.35 0 0 0-.302-4.024Zm0 0"
        style={{
          fill: '#eff3f6',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M232.363 76.102a26.38 26.38 0 0 0-.3-4.024c-7.04-42.683-16.993-40.77-16.993-40.77v.098-.097s-.601-.102-1.605.402c2.512 5.133 10.453 22.547 11.258 38.754.703 14.898-4.223 22.55-9.551 26.476h.101c9.45.102 17.09-9.261 17.09-20.84Zm0 0"
        style={{
          fill: '#dce2e7',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M215.273 97.547c-9.652 0-17.593-9.567-17.593-21.344 0-1.308.101-2.617.3-3.926v-.199c4.926-29.797 11.16-37.953 14.375-40.27 1.208-.804 2.114-.902 2.516-.902h.102c.097 0 1.203-.203 3.015 1.004 3.317 2.317 9.649 10.672 14.575 40.168v.098c.203 1.308.304 2.719.304 4.027 0 11.68-7.945 21.344-17.594 21.344Zm-16.285-25.57v.199a25.558 25.558 0 0 0-.304 3.926c0 11.277 7.441 20.335 16.59 20.335 9.148 0 16.585-9.16 16.585-20.335 0-1.309-.101-2.618-.3-3.926v-.098c-6.235-37.45-14.579-40.066-16.184-40.27-.102.102-.203.102-.305.102-.097 0-.199 0-.3-.101-1.407.203-9.551 2.52-15.782 40.168Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M215.07 116.973c-.3 0-.5-.2-.5-.504V75.902c0-.3.2-.504.5-.504.305 0 .504.204.504.504v40.567c0 .304-.199.504-.504.504Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M214.871 84.96c-.101 0-.203 0-.3-.1l-6.235-4.426c-.2-.204-.3-.504-.102-.707.203-.2.504-.301.703-.102l6.235 4.43c.203.203.3.504.101.707-.101.199-.203.199-.402.199Zm.301 5.235c-.2 0-.3-.101-.402-.199-.2-.203-.102-.504.101-.707l6.23-4.43c.204-.199.504-.097.708.102.199.203.097.504-.102.707l-6.234 4.426c-.098.101-.2.101-.301.101Zm-11.359-28.386c-.204 0-.301-.204-.301-.403.902-6.039 2.914-12.082 4.422-16.105.101-.203.203-.305.402-.203.203.101.3.203.203.402-1.512 4.027-3.52 9.965-4.426 16.008 0 .199-.101.3-.3.3Zm5.429-18.321h-.101c-.203-.101-.203-.304-.203-.402 1.109-2.719 1.91-4.43 1.91-4.43.101-.203.304-.203.402-.203.203.102.203.305.203.402 0 0-.805 1.711-1.91 4.43-.102.102-.203.203-.3.203ZM45.176 62.816h-2.11c-.203 0-.3-.203-.3-.304 0-.2.199-.301.3-.301h2.11c.703 0 1.207-.504 1.207-1.106 0-.605-.602-1.109-1.207-1.109h-2.11c-.203 0-.3-.2-.3-.3 0-.102.199-.301.3-.301h2.11c1.105 0 1.91.804 1.91 1.808 0 1.008-.805 1.613-1.91 1.613Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M76.543 83.352c-.504-7.348-5.629-10.774-9.852-12.282-2.515-.906-4.023-3.422-3.82-6.039a5.43 5.43 0 0 0 0-1.812c-.3-6.946-6.031-12.582-12.969-12.887-7.84-.3-14.277 5.84-14.277 13.59v.305c.102 3.218-1.809 6.039-4.621 7.449-3.723 1.71-7.844 5.234-7.942 11.875 0 3.523 1.407 6.746 3.618 9.261 2.312 3.829 11.761 6.645 23.02 6.645 10.456 0 19.304-2.414 22.417-5.84 2.715-2.715 4.727-6.34 4.426-10.265Zm0 0"
        style={{
          fill: '#eff3f6',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M66.691 70.969c-2.515-.906-4.023-3.422-3.82-6.04a5.43 5.43 0 0 0 0-1.812c-.3-6.945-6.031-12.582-12.969-12.887-1.406-.097-2.715.102-4.023.407v.5s10.559 1.21 11.262 8.758c.703 7.55-1.106 11.476 2.011 16.914 3.114 5.433 1.91 22.648-16.187 21.742v.304c2.113.2 4.324.301 6.637.301 10.453 0 19.3-2.418 22.418-5.84 2.714-2.515 4.625-6.039 4.421-9.964-.402-7.348-5.527-10.774-9.75-12.383Zm0 0"
        style={{
          fill: '#dce2e7',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M49.8 99.457c-11.257 0-20.808-2.816-23.32-6.742-2.414-2.621-3.722-5.942-3.62-9.363.1-6.946 4.523-10.47 8.144-12.18 2.71-1.309 4.523-4.129 4.422-7.149v-.3c0-3.828 1.508-7.45 4.324-10.067 2.813-2.617 6.434-4.027 10.254-3.828 7.137.305 12.969 6.14 13.27 13.29v1.913c-.204 2.516 1.206 4.832 3.617 5.739 4.324 1.609 9.55 5.132 10.054 12.582.2 3.625-1.41 7.449-4.523 10.265-3.219 3.524-12.367 5.84-22.621 5.84Zm-.402-48.922c-3.418 0-6.632 1.309-9.148 3.723-2.613 2.515-4.121 5.941-4.121 9.562v.203c.101 3.32-1.809 6.34-4.824 7.75-3.52 1.614-7.64 4.934-7.742 11.579 0 3.32 1.207 6.441 3.519 8.957 2.414 3.828 11.961 6.445 22.82 6.445 10.153 0 19-2.317 22.118-5.738 2.914-2.72 4.523-6.243 4.32-9.766-.5-7.148-5.426-10.469-9.55-12.078-2.614-1.008-4.22-3.625-4.02-6.445a5.43 5.43 0 0 0 0-1.813c-.301-6.742-5.93-12.277-12.668-12.582-.301.203-.5.203-.704.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M49.297 117.578c-.2 0-.3-.203-.3-.305V76.81c0-.204.202-.305.3-.305.101 0 .305.203.305.305v40.367c0 .199-.102.402-.305.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M49.098 89.895c-.102 0-.102 0-.2-.102l-9.148-6.441c-.203-.102-.203-.301-.102-.504.102-.203.301-.203.504-.102l9.145 6.445c.203.098.203.301.101.5-.101.102-.199.204-.3.204Zm.3 4.73c-.101 0-.199 0-.3-.102-.102-.199-.102-.402.101-.5l7.239-5.136c.199-.102.402-.102.5.101.101.203.101.403-.098.504l-7.238 5.133h-.204ZM39.043 63.82c-.098 0-.098 0 0 0-.098 0-.2-.097-.2-.199.805-8.457 7.743-10.367 7.84-10.469.102 0 .204 0 .305.2 0 .101 0 .203-.203.304-.101 0-6.734 1.91-7.539 10.067 0 0-.101.097-.203.097Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M110.824 59.695s-.707 0-2.113.805c-1.406.805-2.012 2.516-1.207 3.625.906 1.105 2.215.402 2.215.402h3.617s1.61-.203 1.61-1.613c0-1.309-.505-3.117-.505-3.117Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M114.8 58.4c.4-1.598.1-2.2.1-2.2-1.1 0-1.799.699-1.799.699-.8-.3-1.702 0-1.702 0s-.7-.699-1.799-.699c0 0-.4.602.101 2.2 0 0-.7 1.6.898 2.2 1.6.598 2.6.198 3.303 0 .7-.201 1.197-1.101.998-1.8Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3486,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M109.798 56.398s.603.5 1.003 1.001c0 0-.602.4-1.003 1.001m5.002-2.002s-.6.5-1 1.001c0 0 .6.4 1 1.001m-2.6 1.2h.4"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.2681,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M111.699 59.898s0 .303.303.303c.299 0 .299-.5.299-.5m.699.197s0 .303-.299.303c-.3 0-.3-.5-.3-.5"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.2413,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M111.93 59.395a.2.2 0 0 1-.403 0 .2.2 0 1 1 .403 0Zm2.613 0a.2.2 0 0 1-.402 0 .2.2 0 1 1 .402 0Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M107.199 62.498s-.097.5.501.803c.501.198 1.2.097 1.9-.5.198-.101.4-.101.502 0 .198.198.198.4 0 .597l-.203.202c-.598.5-.998.699-1.6.699-.999 0-2.2-.598-1.698-2.2.598-2.298 3.1-2.697 3.1-2.697"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3486,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M109.099 64.1h3.699c.4 0 .8-.399.8-.799s-.4-.803-.8-.803c-.396 0-.897 0-1.197-.097"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3486,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M114.1 60.5s.8 3.201-1.1 3.5"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3486,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M267.246 94.324h1.711v22.649h-1.71Zm0 0"
        style={{
          fill: '#e6ebef',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M258.5 105.9h8.101v1.6H258.5Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.5048,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M265.902 83.1v22.8M258.9 83.1v22.8"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.5048,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="m234.101 116.401 2.798-30.5c.202-1.8 1.601-3.1 3.4-3.1 1.8 0 3.202 1.3 3.4 3.1l2.802 30.4m19.401.1 2.798-30.5c.202-1.8 1.6-3.1 3.4-3.1 1.799 0 3.201 1.3 3.4 3.1l2.801 30.4M240.7 82.8h31.1"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.7767,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M242.401 105.9h8.098v1.6h-8.098Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.5048,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M249.699 83.1v22.8M242.7 83.1v22.8"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.5048,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M270.965 81.035c-.098 0-.098 0 0 0l-1.106-.2c-.101 0-.101-.1-.101-.202 0-.102.101-.2.101-.2l1.106-.203c.101 0 .101 0 .101.102s0 .102-.101.102l-.805.199.805.203c.101 0 .101.098.101.098 0 .101-.101.101-.101.101Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M274.785 82.344c-.601 0-1.207-.301-1.406-.403a1.74 1.74 0 0 1-1.406.301c-.403-.097-.707-.3-.907-.601-.3-.606-.3-1.309 0-1.813.403-.605 1.309-.504 1.309-.504.098 0 .098.102.098.102l-.098.101s-.805-.101-1.11.403c-.3.402-.3 1.004 0 1.61.102.202.403.401.708.503.402.102.902 0 1.304-.3h.102s.805.5 1.508.402c0-.102-.102-.204-.203-.403v-.101l.101-.102s.203.102.402 0c-.3-.102-.804-.3-1.105-.605-.2-.2-.402-.301-.504-.5-.3-.305-.5-.606-1.004-.707-.101 0-.101-.102-.101-.2 0-.101.101-.101.203-.101a2.1 2.1 0 0 1 1.004.804c.101.204.3.301.504.504.5.403 1.304.704 1.304.704l.102.101v.102c-.2.199-.402.199-.602.199.098.305.098.504.098.504 0 .101 0 .101-.098.101 0-.203-.101-.101-.203-.101Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M273.078 81.438c-.605 0-.906-.704-1.008-.704 0-.101 0-.101.102-.203.101 0 .101 0 .203.102 0 0 .3.703.902.605 0 0 .203 0 .403-.203 0-.101.101-.101.203 0 0 0 .5.3.8 0 0-.101.102-.101.204 0 .101 0 .101.102 0 .203a.77.77 0 0 1-1.004.098c-.203.203-.504.203-.504.203-.203-.102-.3-.102-.3-.102Zm-1.105-1.208a.103.103 0 0 1-.102.102.103.103 0 0 1-.101-.102c0-.054.046-.101.101-.101.055 0 .102.047.102.101Zm.804 2.918c-.101-.097-.101-.097-.101-.199l.3-.504-.101-.504c0-.101 0-.101.102-.101.101 0 .101 0 .101.101l.098.504v.102l-.399.504c.098.097.098.097 0 .097Zm-.504.102c-.101 0-.101 0 0 0-.101-.102-.101-.102-.101-.2l.3-.503-.097-.402c0-.102 0-.102.098-.102.101 0 .101 0 .101.102l.102.402v.098l-.403.503v.102Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M30.602 113.047h-2.715c-4.325 0-7.844-3.524-7.844-7.852s3.52-7.851 7.844-7.851h2.715c4.32 0 7.84 3.523 7.84 7.851 0 4.328-3.52 7.852-7.84 7.852Zm0 0"
        style={{
          fill: '#eff3f6',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M31.504 97.445a7.921 7.921 0 0 1 4.121 6.946c0 4.328-3.516 7.851-7.84 7.851H25.07c-.3 0-.601 0-.902-.101 1.105.605 2.312.906 3.719.906h2.715c4.32 0 7.84-3.524 7.84-7.852 0-4.027-3.016-7.246-6.938-7.75Zm0 0"
        style={{
          fill: '#dce2e7',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M30.602 113.348h-2.715c-4.426 0-8.145-3.621-8.145-8.153 0-4.43 3.621-8.152 8.145-8.152h2.715c4.421 0 8.14 3.621 8.14 8.152a8.11 8.11 0 0 1-8.14 8.153Zm-2.715-15.703c-4.121 0-7.54 3.421-7.54 7.55 0 4.13 3.419 7.551 7.54 7.551h2.715c4.12 0 7.539-3.422 7.539-7.55 0-4.13-3.418-7.551-7.54-7.551Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M29.094 117.273c-.203 0-.305-.097-.305-.3v-11.88c0-.198.102-.3.305-.3.199 0 .3.102.3.3v11.88c0 .203-.203.3-.3.3Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M29.094 109.824c-.102 0-.102 0-.203-.097l-2.813-2.114c-.101-.101-.203-.304-.101-.406.101-.098.3-.2.402-.098l2.812 2.114c.102.101.204.3.102.402 0 .102-.102.2-.2.2Zm.199-2.114c-.102 0-.2 0-.2-.097-.1-.101 0-.304.098-.406l2.817-1.809c.101-.101.3 0 .402.098.102.102 0 .305-.101.402l-2.813 1.813h-.203Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M61.1 109.502h23.302v2.398H61.099Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.5425,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M80.699 109.502h3.703v2.398h-3.703ZM63.4 111.9h2.199v4.4h-2.2Zm15.6 0h2.2v4.4H79Zm0 0"
        style={{
          fill: '#b9c1c9',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.4837,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M67.594 103.887s3.52.203 4.625 1.511c1.105 1.207-1.207 4.63-1.207 4.63l-4.223-.102Zm0 0"
        style={{
          fill: '#fff',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M70.001 109.3h-6.9c-.502 0-.902-.4-.902-1.001a1 1 0 0 1 1.002-.998c.498 0 1.5 0 1.9-.1"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.4837,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M62.898 103.801s1.104 1.098 2.3 0m-1.196.501V103.3"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.3224,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M65.684 102.277a.2.2 0 1 1-.2-.203c.11 0 .2.09.2.203Zm-1.911 0a.2.2 0 1 1-.2-.203c.11 0 .2.09.2.203Zm1.61.907c0-.223-.406-.403-.903-.403-.5 0-.906.18-.906.403 0 .222.406.402.906.402.497 0 .903-.18.903-.402Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M63.773 103.184h-.199s.102.703.805.804h.101l.098-.707Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M65.184 103.184h.199s-.102.703-.805.804h-.098l-.101-.707Zm0 0"
        style={{
          fill: '#000',
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
        }}
      />
      <Path
        d="M63.201 99.2s-.7-.4-2 .702c-1.201 1.098-1.5 1.897-1.302 2.6.202.698 1.1.496 1.1.496"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.4837,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M62.3 99.999s-1.5 1.7-1.1 3.6c.4 1.902 2.7 1.902 2.7 1.902m-.699-6.301s.3-.3.7-.3c.497 0 .8.198.8.198s.7-.4 1.997.703c1.302 1.098 1.5 1.897 1.302 2.6-.202.698-1.1.5-1.1.5"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.4837,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
      <Path
        d="M65.502 99.999s1.5 1.7 1.1 3.6c-.4 1.902-2.701 1.902-2.701 1.902m8.401 1.8s.097.598-.603.9c-.598.199-1.399.098-2.199-.6a.48.48 0 0 0-.7 0 .478.478 0 0 0 0 .698l.199.202c.7.597 1.2.799 2 .799 1.202 0 2.6-.699 2.002-2.6-.8-2.7-3.8-3.201-3.8-3.201s-1.302-.198-2.3-.3M66.8 109.3h-6.901c-.498 0-.898-.4-.898-1.001A1 1 0 0 1 60 107.3c.5 0 1.5 0 1.9-.1l.602-2.003"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeOpacity: 1,
          strokeWidth: 0.4837,
        }}
        transform="matrix(1.0053 0 0 1.00666 .14 0)"
      />
    </Svg>
  );
};

export default MarketingSummer;
